import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { MailToSystemAdminSupportLink } from '../components/shared/MailToSystemAdminSupportLink';
import { Stack } from 'react-bootstrap';

export function ErrorPage() {
    const error = useRouteError();

    let message: string;

    if (isRouteErrorResponse(error)) {
        message = `${error.status} ${error.statusText}`;
    } else if (error instanceof Error) {
        message = error.message;
    } else {
        message = 'Unknown error occurred';
    }

    console.error(message);

    return (
        <div className="px-4 pt-4">
            <Stack direction="horizontal" gap={2} style={{ alignItems: 'center' }}>
                <i className="far fa-triangle-exclamation fa-lg" />
                <h1 style={{ marginBottom: 0 }}>Oops!</h1>
            </Stack>

            <p className="mt-2">We have encountered an unexpected problem. Please try again.</p>
            <p>
                We have encountered an unexpected problem. If the problem persists, please contact
                your administrator at <MailToSystemAdminSupportLink />
            </p>
        </div>
    );
}
